import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';

export function AppLayout() {
  // Мобильный режим (< md): сайдбар — выдвижное меню по кнопке в верхней
  // панели. На десктопе сайдбар статичный, панель скрыта — как раньше.
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  // Переход по ссылке меню — закрываем меню.
  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!navOpen) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setNavOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navOpen]);

  return (
    // 100dvh, а не h-screen: на мобильных 100vh включает зону под адресной
    // строкой — низ страницы уезжал бы под неё.
    <div className="flex h-[100dvh] overflow-hidden bg-bg text-text">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-12 shrink-0 items-center gap-2 border-b border-border bg-bg2 px-2 md:hidden">
          <button
            type="button"
            onClick={() => setNavOpen(true)}
            aria-label="Открыть меню"
            aria-expanded={navOpen}
            className="inline-flex h-9 w-9 items-center justify-center rounded-md text-lg text-text2 transition-colors duration-150 hover:bg-bg3 hover:text-text"
          >
            ☰
          </button>
          <span className="text-sm font-semibold tracking-tight text-text">Wave Panel</span>
        </header>
        <main className="min-w-0 flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
